import { getCandidates } from 'api/generated/api/candidates';
import type { CandidateCampaignAccessResponse } from 'api/generated/types';
import { createBootRequest } from 'candidate-app/bootRequests';
import {
  inspectSelectionSearch,
  isIncompleteCandidateJobPair,
  SelectionSearchStatus,
} from 'utils/selectionDeepLink';

/**
 * The shared transcript's access check (useGetTranscriptAccess), started by the
 * recruiter boot so it overlaps the app's download, keyed by
 * transcriptAccessRequestKey.
 */
export const bootTranscriptAccess =
  createBootRequest<CandidateCampaignAccessResponse>();

export const transcriptAccessRequestKey = (
  candidateId: string,
  campaignId: string
): string => JSON.stringify([candidateId, campaignId]);

/**
 * Starts the access check NoLoginCampaignTranscript sends for the page's
 * `search`, or nothing when the page would not send one (a malformed or
 * one-sided candidate/job pair).
 */
export function startTranscriptAccessRequest(search: string): void {
  const params = new URLSearchParams(search);
  if (
    inspectSelectionSearch(search).status !== SelectionSearchStatus.OK ||
    isIncompleteCandidateJobPair(params)
  ) {
    return;
  }
  const candidateId = params.get('candidateId');
  const campaignId = params.get('campaignId');
  if (!candidateId || !campaignId) return;
  bootTranscriptAccess.start(
    transcriptAccessRequestKey(candidateId, campaignId),
    () =>
      getCandidates().candidatesGetCandidateCampaignAccess(
        candidateId,
        campaignId
      )
  );
}
